export const SLICE_KEYS = {
   APPLICATION_SLICE: 'APPLICATION_SLICE',
   GLOBAL_CONFIGURATION_SLICE: 'GLOBAL_CONFIGURATION_SLICE',
   HUB_SLICE: 'HUB_SLICE',
   CONSENTS_SLICE: 'CONSENTS_SLICE',
   FORM_SLICE: 'FORM_SLICE',
   INSTALMENTS_MONTHS_SLICE: 'INSTALMENTS_MONTHS_SLICE',
   CONTRACT_SIGN_SLICE: 'CONTRACT_SIGN_SLICE',
   TEXT_CONTENTS_SLICE: 'TEXT_CONTENTS_SLICE',
   VIDEO_VERIFICATION_SLICE: 'VIDEO_VERIFICATION_SLICE',
}